type FoldAnimation = (
    target: string | HTMLElement,
    cb: () => unknown,
    duration?: number,
    animatePadding?: boolean
) => void;

const foldAnimation: FoldAnimation = (target, cb, duration = 600, animatePadding = false) => {
    const element = typeof target === 'string' ? document.querySelector<HTMLElement>(target) : target;

    if (!element) {
        return;
    }

    const sectionHeight = element.scrollHeight;

    const transitionTiming = `${duration}ms ease-out`;
    const elementTransition = `height ${transitionTiming} ${animatePadding ? `, padding ${transitionTiming}` : ''}`;

    element.style.transition = '';

    requestAnimationFrame(() => {
        element.style.height = `${sectionHeight}px`;
        element.style.transition = elementTransition;
        element.style.overflow = 'hidden';

        requestAnimationFrame(() => {
            element.style.minHeight = `${0}px`;
            element.style.height = `${0}px`;
            element.style.padding = `${0}px`;
        });
    });

    setTimeout(cb, duration);
};

export default foldAnimation;
